import { formatImageSource } from '../../../pages/ProductSearch/helpers';

type ImageProps = {
  productImageUrl: string;
  title: string;
  isSelected?: boolean;
};

export function Image({ productImageUrl, title, isSelected }: ImageProps) {
  const imageSize = isSelected ? 108 : 114;
  const image = formatImageSource(productImageUrl, 150, false, 80);

  if (!image || !image.src) {
    return (
      <img
        alt={title}
        src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"
        width={imageSize}
        height={imageSize}
        style={{
          objectFit: 'cover' as const,
          filter: 'brightness(0.95)',
          borderRadius: 24,
          height: imageSize,
          width: imageSize,
        }}
      />
    );
  }

  return (
    <img
      title={title}
      alt={title}
      loading="lazy"
      src={image.src}
      width={imageSize}
      height={imageSize}
      style={{
        objectFit: 'cover' as const,
        filter: 'brightness(0.95)',
        borderRadius: 24,
        height: imageSize,
        width: imageSize,
      }}
    />
  );
}
